import React from 'react';
import { useDarkMode } from '../contexts/DarkModeContext';

const ProductCardSkeleton = () => {
  const { isDarkMode } = useDarkMode();
  
  return (
  <div className={`animate-pulse rounded-2xl shadow-lg flex flex-col overflow-hidden w-full h-full min-h-[400px] sm:min-h-[450px] lg:min-h-[500px] transition-all duration-500 ${
    isDarkMode 
      ? 'bg-gradient-to-br from-[#2a2a2a] via-[#1a1a1a] to-[#2a2a2a] shadow-2xl shadow-black/50 border border-gray-700/50' 
      : 'bg-white border border-gray-100'
  }`}>
    {/* Image area */}
    <div className={`w-full aspect-[4/3] transition-colors duration-300 ${
      isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
    }`} />
    {/* Category row */}
    <div className="flex items-center gap-2 px-3 sm:px-4 lg:px-5 mt-3 mb-3 sm:mb-4">
      <div className={`w-16 sm:w-20 lg:w-24 h-4 sm:h-5 lg:h-6 rounded transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
      }`} />
      <div className={`w-12 sm:w-14 lg:w-16 h-4 sm:h-5 lg:h-6 rounded ml-2 transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-600' : 'bg-gray-100'
      }`} />
    </div>
    {/* Title */}
    <div className="px-3 sm:px-4 lg:px-5 flex-1">
      <div className={`h-4 sm:h-5 lg:h-6 rounded w-3/4 mb-2 transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
      }`} />
      <div className={`h-3 sm:h-4 rounded w-1/2 mb-3 transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-600' : 'bg-gray-100'
      }`} />
      <div className={`border-b mb-3 sm:mb-4 transition-colors duration-300 ${
        isDarkMode ? 'border-gray-700' : 'border-gray-200'
      }`} />
    </div>
    {/* Price row */}
    <div className="flex items-center px-3 sm:px-4 lg:px-5 mb-3 sm:mb-4 gap-2">
      <div className={`h-4 sm:h-5 lg:h-6 w-8 sm:w-10 rounded transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
      }`} />
      <div className={`h-4 sm:h-5 lg:h-6 w-12 sm:w-14 lg:w-16 rounded transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
      }`} />
      <div className={`h-3 sm:h-4 lg:h-5 w-8 sm:w-10 lg:w-12 rounded ml-1 transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-600' : 'bg-gray-100'
      }`} />
      <div className={`h-3 sm:h-4 lg:h-5 w-14 sm:w-16 lg:w-20 rounded ml-2 transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-600' : 'bg-gray-100'
      }`} />
    </div>
    {/* Button */}
    <div className="px-3 sm:px-4 lg:px-5 pb-3 sm:pb-4 lg:pb-5 mt-auto">
      <div className={`w-full h-8 sm:h-9 lg:h-10 rounded-xl transition-colors duration-300 ${
        isDarkMode ? 'bg-gray-700' : 'bg-gray-200'
      }`} />
    </div>
  </div>
  );
};

export default ProductCardSkeleton; 